import { Provider } from '@angular/core';
import { TaskDataHttpService } from './abstract';
import { TaskDataHttpServiceImpl } from './task-data-http.service';

export const TaskDataHttpProvider: Provider = {
	provide: TaskDataHttpService,
	useClass: TaskDataHttpServiceImpl,
};
